import React, { useState } from "react";
import { connect } from "react-redux";

import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/plain.css";

import { userLogin, userSignup } from "../Actions";

import salcitLogo from "../Assets/images/Swaasa.png";
import { Link } from "react-router-dom";

const LoginForm = (props) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(false);

  const onLogin = (e) => {
    e.preventDefault();
    setError(false);
    if (
      !/^[A-Za-z0-9]+([._%+-]{0,1}[A-Za-z0-9]+)*@[A-Za-z0-9-]+(\.[A-Za-z]{2,})*$/.test(
        email
      )
    ) {
      setError(true);
    } else if (password.length === 0) {
      setError(true);
    } else if (!error) {
      let formData = new FormData();
      formData.append("loginId", email);
      formData.append("password", password);
      // props.userLogin(formData, email);
    }
  };

  return (
    <form className="auth__form" onSubmit={onLogin}>
      <div className="auth__input">
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email"
        />
        {error &&
          !/^[A-Za-z0-9]+([._%+-]{0,1}[A-Za-z0-9]+)*@[A-Za-z0-9-]+(\.[A-Za-z]{2,})*$/.test(
            email
          ) && <p>Enter a valid email</p>}
      </div>
      <div className="auth__input">
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
        />
        {error && password.length === 0 && <p>Password cannot be blank</p>}
      </div>
      <button type="submit" className="auth__form__btn auth__form__btn--login">
        Login
      </button>
      <div>
        {/* <Link to="/admin">
                <button className="auth__form__btn auth__form__btn--login adminbutton" >
                  Admin Login
                </button>
              </Link> */}
      </div>
    </form>
  );
};

const ConnectedLoginForm = connect(null, { userLogin })(LoginForm);

// const SignupForm = (props) => {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [confirmPassword, setConfirmPassword] = useState("");
//   const [name, setName] = useState("");
//   const [location, setLocation] = useState("");
//   const [specialization, setSpecialization] = useState("");
//   const [qualification, setQualification] = useState("");
//   const [hospital, setHospital] = useState("");
//   const [contact, setContact] = useState("");
//   const [age, setAge] = useState("");
//   const [gender, setGender] = useState("");
//   const [zipcode, setZipcode] = useState("");
//   const [error, setError] = useState(false);

//   const onSignup = (e) => {
//     e.preventDefault();

//     setError(false);

//     if (name === "" || name.trim() === "") {
//       setError(true);
//     } else if (
//       !/^[A-Za-z0-9]+([._%+-]{0,1}[A-Za-z0-9]+)*@[A-Za-z0-9-]+(\.[A-Za-z]{2,})*$/.test(
//         email
//       )
//     ) {
//       setError(true);
//     } else if (password.length < 8 || password.length > 30) {
//       setError(true);
//     } else if (password !== confirmPassword) {
//       setError(true);
//     } else if (specialization === "" || specialization.trim() === "") {
//       setError(true);
//     } else if (contact === "") {
//       setError(true);
//     } else if (hospital === "" || hospital.trim() === "") {
//       setError(true);
//     } else if (qualification === "" || qualification.trim() === "") {
//       setError(true);
//     } else if (location === "" || location.trim() === "") {
//       setError(true);
//     } else if (age === "" || age.trim() === "") {
//       setError(true);
//     } else if (gender === "" || gender.trim() === "") {
//       setError(true);
//     } else if (zipcode === "" || zipcode.trim() === "") {
//       setError(true);
//     } else if (!error) {
//       let formData = new FormData();
//       formData.append("loginId", email);
//       formData.append("password", password);
//       formData.append("password", password);
//       formData.append("name", name);
//       formData.append("locations", location);
//       formData.append("specializations", specialization);
//       formData.append("qualifications", qualification);
//       formData.append("hospitals", hospital);
//       formData.append("contact", contact);
//       formData.append("age", age);
//       formData.append("gender", gender);
//       formData.append("zipcode", zipcode);
//       props.userSignup(formData);
//     }
//   };

//   return (
//     <form className="auth__form" onSubmit={onSignup}>
//       <div className="auth__input">
//         <input
//           type="email"
//           value={email}
//           onChange={(e) => setEmail(e.target.value)}
//           placeholder="Email"
//         />
//         {error &&
//           !/^[A-Za-z0-9]+([._%+-]{0,1}[A-Za-z0-9]+)*@[A-Za-z0-9-]+(\.[A-Za-z]{2,})*$/.test(
//             email
//           ) && <p>Enter a valid email</p>}
//       </div>
//       <div className="auth__input">
//         <input
//           type="password"
//           value={password}
//           onChange={(e) => setPassword(e.target.value)}
//           placeholder="Password"
//         />
//         {error && (password.length < 8 || password.length > 30) && (
//           <p>Password length should be 8 to 30 characters</p>
//         )}
//       </div>
//       <div className="auth__input">
//         <input
//           type="password"
//           value={confirmPassword}
//           onChange={(e) => setConfirmPassword(e.target.value)}
//           placeholder="Confirm Password"
//         />
//         {error && password !== confirmPassword && (
//           <p>Password and confirm password should be same</p>
//         )}
//       </div>
//       <div className="auth__input">
//         <input
//           type="text"
//           value={name}
//           onChange={(e) => setName(e.target.value)}
//           placeholder="Name"
//         />
//         {error && (name === "" || name.trim() === "") && (
//           <p>Name cannot be blank</p>
//         )}
//       </div>
//       <div className="auth__input">
//         <input
//           type="text"
//           value={location}
//           onChange={(e) => setLocation(e.target.value)}
//           placeholder="Location"
//         />
//         {error && (location === "" || location.trim() === "") && (
//           <p>Location cannot be blank</p>
//         )}
//       </div>
//       <div className="auth__input">
//         <input
//           type="text"
//           value={specialization}
//           onChange={(e) => setSpecialization(e.target.value)}
//           placeholder="Specialization"
//         />
//         {error && (specialization === "" || specialization.trim() === "") && (
//           <p>Specialization cannot be blank</p>
//         )}
//       </div>
//       <div className="auth__input">
//         <input
//           type="text"
//           value={qualification}
//           onChange={(e) => setQualification(e.target.value)}
//           placeholder="Qualification"
//         />
//         {error && (qualification === "" || qualification.trim() === "") && (
//           <p>Qualification cannot be blank</p>
//         )}
//       </div>
//       <div className="auth__input">
//         <input
//           type="text"
//           value={hospital}
//           onChange={(e) => setHospital(e.target.value)}
//           placeholder="Hospital"
//         />
//         {error && (hospital === "" || hospital.trim() === "") && (
//           <p>Hospital cannot be blank</p>
//         )}
//       </div>
//       <div className="auth__input">
//         <PhoneInput
//           country={"in"}
//           value={contact}
//           onChange={(contact) => setContact(contact)}
//           enableSearch
//           disableSearchIcon
//           inputStyle={{
//             width: "100%",
//             border: "none",
//             borderBottom: "0.2rem solid #1d1602",
//           }}
//           buttonStyle={{
//             border: "none",
//             borderBottom: "0.2rem solid #1d1602",
//             backgroundColor: "#fff",
//           }}
//         />
//         {error && (contact === "" || contact.trim() === "") && (
//           <p>Contact cannot be blank</p>
//         )}
//       </div>
//       <div className="auth__input">
//         <input
//           type="number"
//           value={age}
//           onChange={(e) => setAge(e.target.value)}
//           placeholder="Age"
//         />
//         {error && (age === "" || age.trim() === "") && (
//           <p>Age cannot be blank</p>
//         )}
//       </div>
//       <div className="auth__input">
//         <input
//           type="text"
//           value={gender}
//           onChange={(e) => setGender(e.target.value)}
//           placeholder="Gender"
//         />
//         {error && (gender === "" || gender.trim() === "") && (
//           <p>Gender cannot be blank</p>
//         )}
//       </div>
//       <div className="auth__input">
//         <input
//           type="text"
//           value={zipcode}
//           onChange={(e) => setZipcode(e.target.value)}
//           placeholder="Pin Code"
//         />
//         {error && (zipcode === "" || zipcode.trim() === "") && (
//           <p>Pin Code cannot be blank</p>
//         )}
//       </div>
//       <button type="submit" className="auth__form__btn">
//         Signup
//       </button>
//     </form>
//   );
// };

// const ConnectedSignupForm = connect(null, { userSignup })(SignupForm);

const Auth = () => {
  const [tab, setTab] = useState("login");

  return (
    <div className="auth">
      <div className="auth__content">
        <div className="auth__logo">
          <img src={salcitLogo} alt="logo" />
        </div>
        <div className="auth_welcome">
          <p>Welcome to Doctor & Health Worker Dashboard</p>
        </div>
        <div className="auth__tabs">
          <div
            className="auth__tab"
            onClick={() => setTab("login")}
            style={
              tab === "login" ? { borderBottom: "0.2rem solid #1d1602" } : {}
            }
          >
            <p>Login</p>
          </div>
          {/* <div
            className="auth__tab"
            onClick={() => setTab("signup")}
            style={
              tab === "signup" ? { borderBottom: "0.2rem solid #1d1602" } : {}
            }
          >
            <p>Signup</p>
          </div> */}
        </div>
        {(() => {
          switch (tab) {
            case "login":
              return <ConnectedLoginForm />;

            // case "signup":
            //   return <ConnectedSignupForm />;

            default:
              break;
          }
        })()}
      </div>
    </div>
  );
};

export default Auth;
